// src/utils/migrations.ts
import { supabase } from './supabase';
import { createLogger } from './logger';

const logger = createLogger({ module: 'migrations' });

export const updateFileSizes = async () => {
  try {
    // Get all files without size
    const { data: files, error } = await supabase
      .from('files')
      .select('*')
      .is('size', null)
      .eq('source', 'local');

    if (error) {
      console.error('Error fetching files:', error);
      return;
    }

    if (!files || files.length === 0) {
      logger.debug('No files need size updates');
      return;
    }

    console.log(`Updating sizes for ${files.length} files...`);

    // Update each file with its size
    for (const file of files) {
      try {
        // Get file metadata from storage
        const { data: fileData, error: storageError } = await supabase
          .storage
          .from('resumes')
          .list(file.file_path.split('/')[0], {
            search: file.file_path.split('/').pop()
          });

        if (storageError) throw storageError;

        if (fileData?.[0]?.metadata?.size) {
          // Update the file record with the size
          const { error: updateError } = await supabase
            .from('files')
            .update({ size: fileData[0].metadata.size })
            .eq('id', file.id);

          if (updateError) throw updateError;
          
          console.log(`Updated size for file ${file.file_name}`);
        }
      } catch (error) {
        console.error(`Error updating size for file ${file.id}:`, error);
      }
    }

    console.log('File size update completed');
  } catch (error) {
    console.error('Error in updateFileSizes:', error);
  }
};